import computed from './computed'
import methods from './methods'

export { computed, methods }

export default {
  ...computed,
  ...methods
}
